document.addEventListener("DOMContentLoaded", function(event) {
  if(navigator.platform.indexOf('Win') > -1) {
    document.body.classList.add("os-windows");
  }
});

document.addEventListener("DOMContentLoaded", function(event) {
  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  if (sizeParam) {
    document.querySelectorAll(".ColorSwatchList a").forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    }); 
  } 
});

document.addEventListener('variant:change', function(event) {
  let selectedSize = event.detail.variant.option2.replace(/\s/g, "").toLowerCase();
  document.querySelectorAll(".ColorSwatchList a").forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
  });  
});

document.addEventListener('variant:change', function(event) {
  let selectedVariant = $(event.target).find('input[name="id"]').val()
  let selectedVariantMessage = $(event.target).find('[variant-id="' + selectedVariant + '"]').attr('variant-id-message');
  if (selectedVariantMessage) {
    $('.buy-buttons').addClass('pre-order-button');
    $('[name="properties-null[Pre-Order]"]').attr( 'name','properties[Pre-Order]');
  } else {
    $('.buy-buttons').removeClass('pre-order-button');
    $('[name="properties[Pre-Order]"]').attr( 'name','properties-null[Pre-Order]');
  }
  $('.buy-buttons .button span').hide();
  $('.buy-buttons .button span[variant-id="' + selectedVariant + '"]').show();
  $('[name="properties[Pre-Order]"]').val(selectedVariantMessage);
});

const siteSelector = document.querySelector('.Header__SiteSelector');
if(siteSelector) {
  siteSelector.addEventListener('click', function() {
    siteSelector.classList.toggle('is-active');
  });
}

const siteSelectorMobile = document.querySelector('.header-sidebar__main-panel .Header__SiteSelector');
if(siteSelectorMobile) {
  siteSelectorMobile.addEventListener('click', function() {
    siteSelectorMobile.classList.toggle('is-active');
  });
}

document.addEventListener('DOMContentLoaded', function(event) {
  const productRecommendations = document.querySelector('product-recommendations');
  if(productRecommendations) {   
    setTimeout(function() {
      if (typeof window['yotpo'] !== 'undefined') {
        window['yotpo'].initWidgets();
      }
    }, 1500);
  }
});;

$(document).on('click', '.facets-sentence-trigger span', function() {
  $('.facets-sentence-trigger .facets-sentence-dropdown').each(function() {
    $(this).removeClass('active');
  });
  $(this).siblings(".facets-sentence-dropdown").addClass('active');
});

document.addEventListener("facet:update",function(event) {
  setTimeout(function() {
    if (typeof window['yotpo'] !== 'undefined') {
      window['yotpo'].initWidgets();
    }
  }, 1500);
});

const stickyElm = document.querySelector('.collection-toolbar')
if (stickyElm) {
  const observer = new IntersectionObserver( 
    ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
    {threshold: [1]}
  );
  
  observer.observe(stickyElm)
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible'); // Add 'visible' class
    } else {
      entry.target.classList.remove('visible'); // Remove 'visible' class
    }
  });
});

const sizeChartArrows = document.querySelectorAll('.size-guide-popup-table .prev-next-button'); // Select elements to observe
sizeChartArrows.forEach(element => {
  observer.observe(element);
});

let ratingWidget = document.querySelector('.shopify-app-block [data-oke-star-rating]');
let reviewWidget = document.querySelector('.shopify-app-block [data-oke-widget]');
if(ratingWidget) {
  ratingWidget.addEventListener('click', function(event) {
    console.log('clicked');
    setTimeout(() => {
      reviewWidget.scrollIntoView({
        top: 0,
        left: 0,
        behavior: 'smooth' // For smooth scrolling animation
      });
    }, "200");
      
  });
}

// document.addEventListener('theme:loading:end', function(event) {
//   setTimeout(function() {
//     var api = new Yotpo.API(yotpo);
//     api.refreshWidgets();
//   }, 100);
// });

// $(document).on('click', 'quick-buy-modal .ColorSwatch', function (event) {
//   setTimeout(function() {
//       const quickBuyDrawer = event.target.closest('quick-buy-modal');
//       const shadowRoot = quickBuyDrawer.shadowRoot;
//       const quickBuyDrawerClose = shadowRoot.querySelector('[is="dialog-close-button"]');
//       quickBuyDrawerClose.click();
//   }, 300);
//   console.log('close drawer');
// });

$(document).on('click', function (e) {
  if ($(e.target).closest(".facets-sentence-trigger").length === 0 && !$(e.target).hasClass("facets-sentence-trigger")) {
     $(".facets-sentence-dropdown").removeClass("active");
  }

  if ($(e.target).closest(".facets-sentence-dropdown-close").length != 0) {
     $(".facets-sentence-dropdown").removeClass("active");
  }
});

$('.collection-description__toggle').click(function(){
  $('.collection-description').toggleClass('shown-overflow hidden-overflow');
});

$(document).ready(function () {
  var panelHeight = $('.tabs-desktop input[type=radio]:checked').closest('.tab').find('.panel').height();
  $('.tabs-desktop').css('min-height', panelHeight);
});

$('.tabs-desktop input[type=radio]').change(function() {
    var panelHeight = $(this).closest('.tab').find('.panel').height();
    $('.tabs-desktop').css('min-height', panelHeight);
});

$('.tabs-mobile input[type=radio]').change(function() {
  
    $('.content-mobile .panel').hide();
  
    var panelActiveID = $(this).attr('id')
    $('.content-mobile [data-tab="' + panelActiveID + '"]').show();
});

$('body').on('click','#shopify-section-page-size-guide-template .size-guide-popup-tabs ul li', function(e) {
  e.preventDefault();

  if (!$(this).hasClass("tab-active")) {
    $('#shopify-section-page-size-guide-template .size-guide-popup-tabs ul li').toggleClass('tab-active')
    $('#shopify-section-page-size-guide-template .size-guide-popup-content > div').toggleClass('content-active')
  }
  
});

$('body').on('click','#shopify-section-page-size-guide-template .size-guide-popup-measurements ul li', function(e) {
  e.preventDefault();

  if (!$(this).hasClass("measurement-active")) {
    $('#shopify-section-page-size-guide-template .size-guide-popup-measurements ul li').toggleClass('measurement-active')
    $('#shopify-section-page-size-guide-template .size-guide-popup-content .measurement-conversion').toggleClass('m-cm m-in')
  }
  
});

$(document).on('click','#size-guide-popup .size-guide-popup-tabs ul li', function(e) {
  e.preventDefault();

  if (!$(this).hasClass("tab-active")) {
    $('#size-guide-popup .size-guide-popup-tabs ul li').toggleClass('tab-active')
    $('#size-guide-popup .size-guide-popup-content > div').toggleClass('content-active')
  }
  
});

$(document).on('click','#size-guide-popup .size-guide-popup-measurements ul li', function(e) {
  e.preventDefault();

  if (!$(this).hasClass("measurement-active")) {
    $('#size-guide-popup .size-guide-popup-measurements ul li').toggleClass('measurement-active')
    $('#size-guide-popup .size-guide-popup-content .measurement-conversion').toggleClass('m-cm m-in')
  }
  
});

$(document).on('click', '.ajax-modal', function (event) {
  event.preventDefault();
  event.stopPropagation();
  this.blur();

    $.get($(this).data('modal-href'), function (html) {
      $(html).find('#size-guide-popup').wrap('<div class="modal"></div>').appendTo('body').modal();
      $(html).find('.gryffeditor').wrap('<div class="modal"></div>').appendTo('body').modal();
    });
});

$(document).on('click', '.upsell-add-to-cart', function(e) {
  e.preventDefault();

  let variant_id = Number($(this).closest('.complete-look__item').find('#upsell-select :selected').data('id'));
  var data = {
    "id": variant_id,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,  //this code is for prestige theme, is to refresh the cart
        detail: {
          quantity: 1
        }
      }));
    }   
  }); 
})

$(document).on('click', '.grid-cross-links label.ColorSwatch', function (e) {
  e.preventDefault();
  e.stopPropagation()

  if ($(this).data('swatch-product-image')) {
    let main_image = $(this).parents('.product-card').find('.product-card__image--primary');
    let alt_image = $(this).parents('.product-card').find('.product-card__image--secondary');

    var newImageElement = document.createElement('img');
    newImageElement.className = 'product-card__image product-card__image--primary  aspect-natural';
    newImageElement.setAttribute('width', '1200px');
    newImageElement.setAttribute('height', '1600px');
    newImageElement.setAttribute('src', $(this).data('swatch-product-image'));

    var newAltImageElement = document.createElement('img');
    newAltImageElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
    newAltImageElement.setAttribute('src', $(this).data('swatch-product-alt-image'));
    
    $(main_image).replaceWith(newImageElement);
    $(alt_image).replaceWith(newAltImageElement);
  }
  var productItem = this.closest('.product-card');
  var variantHandle = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-handle");
  var variantUrl = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-url");
  var variantTitle = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-title");
  var variantPrice = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-price");
  var variantComparePrice = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-compare-price");
  var variantFullPrice = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-full-price");
  var variantAvailable = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-available");
  var swatchProductQuickBuy = $(this).siblings('.ColorSwatch__Radio').attr("data-swatch-product-quickbuy");
  productItem.querySelector('input[type="radio"]:checked').checked = false;
  var newSelectedSwatches = $(this).siblings('.ColorSwatch__Radio');
  var newSelectedSwatch = newSelectedSwatches[0];
  newSelectedSwatch.checked = true;
  if (variantFullPrice == "true") {
    productItem.classList.remove("Sale");
    productItem.classList.add("Full");
  } else {
    productItem.classList.remove("Full");
    productItem.classList.add("Sale");
  }
  if (variantAvailable == "true") {
    productItem.classList.remove("Sold-Out");
    productItem.classList.add("Available");
  } else {
    productItem.classList.remove("Available");
    productItem.classList.add("Sold-Out");
  }
  productItem.setAttribute('handle', variantHandle);
  productItem.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
  productItem.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
  productItem.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
  productItem.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
  productItem.querySelector('.product-card__quick-add-button').setAttribute('aria-controls', swatchProductQuickBuy);
    
});

$(document).on('click', '.swatch-products-more', function () {
  $(this).remove();
});

$('body').on('click', '#modal-SeeSizeModal .config__size', function(e) {
  e.preventDefault();

  var self = $(this);
  var downcase_val = self.attr('data-value').trim().toLowerCase();
  var parent = self.closest('.see-size__content');

  if(self.hasClass('active')) {
    return false;
  }

  parent.find(".see-size__img_block").each(function () {
    var downcase_alt = $(this).attr('data-alt').trim().toLowerCase();

    if(downcase_val == downcase_alt) {
      $(this).removeClass('no-js');
    }else {
      $(this).addClass('no-js');
    }
  });
  parent.find('.measurements').each(function () {
    var downcase_alt = $(this).attr('data-val').trim().toLowerCase();

    if(downcase_val == downcase_alt) {
      $(this).removeClass('no-js');
    }else {
      $(this).addClass('no-js');
    }

  });
  parent.find('.config__size.active').removeClass('active');
  self.addClass('active');


});

window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){}